import React from 'react';
import LegalLayout from '../../components/LegalLayout';
import { ENTREPRISE as E } from '../../data/entreprise';

const Confidentialite = () => (
  <LegalLayout
    titre="Politique de confidentialité"
    description="Politique de confidentialité de surophone.fr : données collectées via le formulaire de rendez-vous, finalités, durée de conservation, droits RGPD."
    path="/politique-de-confidentialite"
  >
    <h2>Responsable du traitement</h2>
    <p>{E.nom} – {E.responsable}, {E.adresse}. Téléphone : <a href={E.telLien}>{E.telAffiche}</a>.</p>

    <h2>Données collectées</h2>
    <p>
      Lorsque vous utilisez le formulaire « Prendre rendez-vous », nous collectons : votre prénom, éventuellement votre nom, votre numéro de téléphone, le type de réparation souhaité et le message que vous rédigez (modèle, description de la panne).
      Lorsque vous nous contactez par téléphone ou WhatsApp, vos échanges sont traités par ces services selon leurs propres conditions.
    </p>

    <h2>Finalités et base légale</h2>
    <p>
      Ces données servent uniquement à vous recontacter, établir un devis, planifier et réaliser la réparation (exécution de mesures précontractuelles et du contrat). Elles ne sont jamais vendues ni utilisées à des fins publicitaires.
    </p>

    <h2>Destinataires</h2>
    <p>
      Les demandes de rendez-vous sont enregistrées dans notre base sécurisée et nous sont notifiées par e-mail et par message WhatsApp via des prestataires techniques (hébergement, envoi d'e-mails, passerelle de notification). Ces prestataires n'accèdent aux données que pour l'exécution de ces services.
    </p>

    <h2>Durée de conservation</h2>
    <p>
      Les demandes de rendez-vous sont conservées 12 mois à compter de leur réception, puis supprimées. Les factures sont conservées pendant la durée légale (10 ans).
    </p>

    <h2>Cookies</h2>
    <p>
      Le site ne dépose pas de cookie publicitaire ni de traceur tiers. Seuls des cookies techniques strictement nécessaires au fonctionnement peuvent être utilisés. Les liens vers Google Maps, WhatsApp ou les polices Google peuvent entraîner l'enregistrement de données par ces services.
    </p>

    <h2>Vos droits</h2>
    <p>
      Conformément au RGPD et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement, de limitation et d'opposition sur vos données. Pour l'exercer, contactez-nous au <a href={E.telLien}>{E.telAffiche}</a> ou par courrier à l'adresse ci-dessus. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
    </p>

    <h2>Sécurité</h2>
    <p>
      Les données sont transmises en HTTPS et stockées sur des serveurs sécurisés. L'accès est restreint au responsable du traitement.
    </p>
  </LegalLayout>
);

export default Confidentialite;
